export default __webpack_public_path__ + "static/media/README.11623364.md";